import React, { useMemo } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MuiAlert from '@material-ui/lab/Alert';
import DOMPurify from 'dompurify';

import { styles } from './styles';

import { useNotification } from '../../../context/notification';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function Notification() {
  const classes = styles();
  const {
    state: { isOpen, timeOut, severity, message },
    dispatchNotification,
  } = useNotification();

  const sanitizeMessage = useMemo(() => {
    return DOMPurify.sanitize(message);
  }, [message]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatchNotification({ show: false });
  };

  return (
    isOpen && (
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        className={classes.root}
        open={isOpen}
        autoHideDuration={timeOut}
        onClose={handleClose}
      >
        <Alert severity={severity}>
          <span className={classes.rootAlert}>
            <span
              className={classes.message}
              dangerouslySetInnerHTML={{ __html: sanitizeMessage }}
            ></span>
            <div>
              <IconButton
                className={classes.iconButton}
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
              >
                <CloseIcon className={classes.closeIcon} fontSize="small" />
              </IconButton>
            </div>
          </span>
        </Alert>
      </Snackbar>
    )
  );
}
